import moment from 'moment'
import * as React from 'react'

import {getDateFormat, getTimeFormat} from '@base/app-services/i18n-format'
import {autobind} from '@base/decorators'
import themeable from '@base/react-utils/themeable'

import GroupLayout from '@base-uikit/layout/GroupLayout'

import * as helpers from './helpers'
import InputDateSelect from './InputDateSelect'
import {TimeInputSelect} from './TimeInputSelect'

import t from 't'

@themeable()
class DateTimePicker extends React.PureComponent {
  @autobind
  handleValueChange(value) {
    const {onValueChange} = this.props
    if (onValueChange) {
      onValueChange(this.datetimeOut(value))
    }
  }

  @autobind
  hackTimeFormatForBackend(value) {
    return helpers.convertTimeToISO(value)
  }

  @autobind
  handleTimeChange(value) {
    if (this.props.isDarthCustomField) {
      return this.handleValueChange({
        date: this.getDate(),
        time: this.hackTimeFormatForBackend(value),
      })
    }
    const {date} = this.datetimeIn()
    return this.handleValueChange({
      date,
      time: helpers.convertTimeToISO(value),
    })
  }

  @autobind
  handleDateChange(value) {
    if (this.props.isDarthCustomField) {
      return this.handleValueChange({
        time: this.getTime(),
        date: value,
      })
    }
    const {time} = this.datetimeIn()
    return this.handleValueChange({date: helpers.convertToISO(value), time})
  }

  @autobind
  hackTimeFormatFromBackend(value) {
    return helpers.splitDateAndTimeDarthCustomField(value)
  }

  @autobind
  datetimeIn() {
    const {isDarthCustomField, value} = this.props
    if (isDarthCustomField) {
      return this.hackTimeFormatFromBackend(value)
    }
    return helpers.splitDateAndTimeISO(value)
  }

  @autobind
  datetimeOut(value) {
    const {date, time} = value
    if (!date) {
      return null
    }

    if (this.props.isDarthCustomField) {
      return `${date} ${time}`
    }

    return helpers.joinDateAndTimeISO(value)
  }

  getDate() {
    const {date} = this.datetimeIn()
    if (this.props.isDarthCustomField) {
      return date
    }
    return helpers.convertFromISO(date)
  }

  getDefaultTime() {
    return moment.utc({hour: 0, minute: 0}).format(getTimeFormat())
  }

  getTime() {
    const {time: inputTime} = this.datetimeIn()
    const time = !inputTime ? this.getDefaultTime() : inputTime

    if (this.props.isDarthCustomField) {
      return time
    }
    return helpers.convertTimeFromISO(time)
  }

  render() {
    const dateTabIndex = this.props.tabIndex || undefined
    const timeTabIndex = this.props.tabIndex && this.props.tabIndex + 1
    return (
      <GroupLayout>
        <InputDateSelect
          {...this.props}
          onValueChange={this.handleDateChange}
          value={this.getDate()}
          placeholder={getDateFormat()}
          tabIndex={dateTabIndex}
          datePresets={this.props.datePresets}
          data-test-id="date-picker-input"
        />
        {this.getDate() && (
          <TimeInputSelect
            timeFormat={getTimeFormat()}
            onValueChange={this.handleTimeChange}
            value={this.getTime()}
            placeholder={t('HH:MM', {
              screenshot: '',
              title: '',
            })}
            canClear={false}
            tabIndex={timeTabIndex}
            data-test-id="time-picker-input"
          />
        )}
      </GroupLayout>
    )
  }
}

export default DateTimePicker
